<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img10_1" src="images/img10_1.jpg"/></p>
<p class="caption">Major General Wood addressing trainee officers at Fort McPherson, First Officers’Training Camp, Plattsburg.</p>
<p class="caption">6US</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01i_AMERICAN_EXPEDITIONARY_FORCE.vue?e4bbf68e